<uni-nav-new-item-container
  *ngIf="subitem"
  [id]="subitem.id"
  [labelKey]="subitem.labelKey"
  [link]="subitem.link"
  [isSubitem]="true"
>
</uni-nav-new-item-container>
